import { Component } from '@angular/core';

@Component({
  selector: 'app-hosting-cloud',
  templateUrl: './hosting-cloud.component.html',
  styleUrls: ['./hosting-cloud.component.css']
})
export class HostingCloudComponent {
  navClass = 'nav-light';
    // Set Topbar Option
  Menuoption = 'hosting';
  Settingicon = true
  footerVariant = 'footer-ten';
}
